import clsx from 'clsx';

interface ConnectionStatusProps {
  isConnected: boolean;
  className?: string;
}

export default function ConnectionStatus({ isConnected, className }: ConnectionStatusProps) {
  return (
    <div className={clsx('flex items-center gap-2', className)}>
      <span className="relative flex h-2.5 w-2.5">
        {isConnected && (
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
        )}
        <span className={clsx(
          'relative inline-flex rounded-full h-2.5 w-2.5',
          isConnected ? 'bg-green-500' : 'bg-red-500'
        )}></span>
      </span>
      <span className={clsx(
        'text-xs font-medium',
        isConnected ? 'text-green-600' : 'text-red-600'
      )}>
        {isConnected ? 'Live' : 'Connecting...'}
      </span>
    </div>
  );
}
